import { CSSProperties } from "react";
import { useCssStateManager } from "../../hooks/use_css_state_manager";

export type HorizontalSpacerProps = {
};

export const horizontalSpacer = (width: number) => {
    return function HorizontalSpacer({}:HorizontalSpacerProps)
    {
        const cssStateManager = useCssStateManager(["horizontal-spacer"]);
        const styles: CSSProperties = {
            width: `${width}rem`
        };
        return (
            <>
                <div className={cssStateManager.getClassNames()} style={styles}></div>
                <style jsx>{`
                .horizontal-spacer {
                    display: inline-block;
                }
                `}</style>
            </>
        );
    }
};

